import React, { useEffect, useMemo, useState } from "react";
import { createUseStyles } from "react-jss";
import { Sidebar } from "./Sidebar";
import {
  useScrollyTellProps,
  useScrollytellDispatch,
  useScrollytellState,
  SET_ACTIVE_ELEMENT,
  SET_A11Y_DRAWER_OPEN,
} from "./scrollytellContext";
import { initializeStory } from "./service";
import { Story } from "../Story/Story";
import { A11yInspectorDrawer } from "../A11yInspector/A11yInspectorDrawer";
import { inspectStory } from "../A11yInspector/A11yInspectorEngine";

const useStyles = createUseStyles({
  admin: {
    display: "flex",
    overflow: "hidden",
    height: "100%",
    width: "100%",
  },
  content: {
    display: "flex",
    height: "100%",
  },
});

export const Admin = ({ sidePanel }) => {
  const { onChange, story } = useScrollyTellProps();
  const state = useScrollytellState();
  const dispatch = useScrollytellDispatch();
  const [currentSection, setCurrentSection] = useState(0);
  const [isPreview] = useState(false);

  const classes = useStyles({});

  const { issues } = useMemo(() => inspectStory(story), [story]);

  useEffect(() => {
    if (
      story === undefined ||
      Object.keys(story).length === 0 ||
      story.sections === undefined
    ) {
      onChange(initializeStory(story));
    }
  }, [story, onChange]);

  useEffect(() => {
    const activeSec = state?.activeElement?.[0];
    if (typeof activeSec === "number" && activeSec >= 0) {
      setCurrentSection(activeSec);
    }
  }, [state?.activeElement]);

  const handleSelectIssue = (target) => {
    dispatch({ type: SET_A11Y_DRAWER_OPEN, open: false });
    if (!target || target.sectionIndex === undefined) return;

    dispatch({
      type: SET_ACTIVE_ELEMENT,
      activeSection: target.sectionIndex,
      activeContainer: target.containerIndex,
      activeBlock: target.blockIndex,
    });

    const targetSection = story?.sections?.[target.sectionIndex];
    const targetContainer = targetSection?.containers?.[target.containerIndex];
    const targetBlock = targetContainer?.blocks?.[target.blockIndex];

    const containerEl =
      target.containerIndex !== undefined
        ? document.getElementById(`container-${target.sectionIndex}-${target.containerIndex}`)
        : null;
    const targetEl =
      containerEl ||
      document.getElementById(`section-${target.sectionIndex + 1}`) ||
      document.getElementById(`section-${target.sectionIndex}`);

    if (targetEl && typeof targetEl.scrollIntoView === "function") {
      targetEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    if (targetBlock?.type === "image") {
      setTimeout(() => {
        const btn = (containerEl || targetEl)?.querySelector?.('[data-a11y-field="imageAltTextBtn"]');
        if (btn && typeof btn.click === "function") {
          btn.click();
          setTimeout(() => {
            const inputEl = document.querySelector('[data-a11y-field="altText"]');
            if (inputEl && typeof inputEl.focus === "function") {
              inputEl.focus();
            }
          }, 150);
        } else {
          const inputEl = (containerEl || targetEl)?.querySelector?.('[data-a11y-field="altText"]');
          if (inputEl && typeof inputEl.focus === "function") {
            inputEl.focus();
          }
        }
      }, 300);
    } else if (targetBlock?.type === "video") {
      setTimeout(() => {
        const btn = (containerEl || targetEl)?.querySelector?.('[data-a11y-field="videoTranscriptBtn"]');
        if (btn && typeof btn.click === "function") {
          btn.click();
          setTimeout(() => {
            const inputEl = document.querySelector('[data-a11y-field="videoTranscript"]');
            if (inputEl && typeof inputEl.focus === "function") {
              inputEl.focus();
            }
          }, 150);
        } else {
          const inputEl = (containerEl || targetEl)?.querySelector?.('[data-a11y-field="videoTranscript"]');
          if (inputEl && typeof inputEl.focus === "function") {
            inputEl.focus();
          }
        }
      }, 300);
    }
  };

  return (
    <div className={classes.admin}>
      <Sidebar
        appBar={story?.appBar}
        sections={story?.sections}
        currentSection={currentSection}
        isOpen={sidePanel}
      />
      {story && (
        <Story
          data={story}
          isAdminMode={!isPreview}
          showGrid={false}
          onSectionChange={setCurrentSection}
          showSidePanel={sidePanel}
        />
      )}
      <A11yInspectorDrawer
        open={Boolean(state?.a11yDrawerOpen)}
        issues={issues}
        onClose={() => dispatch({ type: SET_A11Y_DRAWER_OPEN, open: false })}
        onSelectIssue={handleSelectIssue}
      />
    </div>
  );
};
